module.exports = __webpack_public_path__ + "img/google-podcasts.33122cba.png";